<div class="product-cto-block" [class.discount-block]="false" [class.shop-cto-block]="shopCtoBlockStyles">
  <div class="grid" [class.shipping-and-quantity-inline]="shopCtoBlockStyles">
    <div class="grid-column price-column">
      <div class="price-block">
        <div class="price-line">
          <span>
            @if(searchResult){ @if(searchResult.priceWithTax |
            formatSearchResultPriceTemplate | async; as productPrice){
            {{ productPrice }}
            } @else {
            <div class="loader-wrapper p-unset">
              <p-progressSpinner styleClass="c-loader medium centered-vertically " strokeWidth="2"
                fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
            </div>
            } } @else if(product) { @if(product.variants[0].priceWithTax |
            formatPrice | async; as productPrice){
            {{ productPrice }}
            } @else {
            <div class="loader-wrapper p-unset">
              <p-progressSpinner styleClass="c-loader medium centered-vertically " strokeWidth="2"
                fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
            </div>
            } }
          </span>
        </div>
        <!-- NG IF DISCOUNT FALSE , NOW NO DISCOUNTS IN SEARCHRESULTS ITEM-->
        @if (true) {
        <div class="incl-vat-line">
          <span>incl. VAT</span>
        </div>
        } @else {
        <div class="price-before-discount-line">
          <span> ISK Unknown </span>
        </div>
        }
      </div>
    </div>

    @if (shopCtoBlockStyles) { @if (shippingEnabled) {
    <div class="grid-column shipping-selector-column" [class.shipping-and-quantity-column]="quantityEnabled">
      @if (shippingEnabled) {
      <app-shipping-selector [shippingMethods]="shippingMethods" [smallLabel]="false" [darkMode]="true">
      </app-shipping-selector>
      } @if (quantityEnabled) { @if(searchResult){
      <app-quantity-selector [order]="activeOrder$ | async" [(quantity)]="quantity" [searchResult]="searchResult"
        [smallButtons]="true" [darkMode]="true"></app-quantity-selector>
      } @else if(product){
      <app-quantity-selector [order]="activeOrder$ | async" [(quantity)]="quantity"
        [productVariant]="product?.variants[0]" [smallButtons]="true" [darkMode]="true"></app-quantity-selector>
      } }
    </div>
    } } @else { @if (shippingEnabled) {
    <div class="grid-column shipping-selector-column">
      <app-shipping-selector [shippingMethods]="shippingMethods" [darkMode]="true"></app-shipping-selector>
    </div>

    }
    @if (quantityEnabled) {
    <div class="grid-column quantity-selector-column">
      @if(searchResult){
      <app-quantity-selector [order]="activeOrder$ | async" [(quantity)]="quantity" [searchResult]="searchResult"
        [darkMode]="true"></app-quantity-selector>
      } @else if(product){
      <app-quantity-selector [order]="activeOrder$ | async" [(quantity)]="quantity"
        [productVariant]="product?.variants[0]" [darkMode]="true"></app-quantity-selector>
      }
    </div>
    } }

    <div class="grid-column cart-btn-column mb-12-px" [class.mb-12-px]="false">
      @if(searchResult){
      <app-cart-button (subscribeToNewActiveOrder)="subscribeToActiveOrder()" [searchResult]="searchResult"
        [(quantity)]="quantity" [qtyInCart]="qtyInCart" [orderLineInCart]="orderLineInCart"></app-cart-button>
      } @else if(product){
      <app-cart-button (subscribeToNewActiveOrder)="subscribeToActiveOrder()" [productVariant]="product?.variants[0]"
        [(quantity)]="quantity" [qtyInCart]="qtyInCart" [orderLineInCart]="orderLineInCart"></app-cart-button>
      }
    </div>
  </div>

  <div class="sub-actions mt-12-px">
    @if(stockLevel > 0){
    <span class="in-stock-text">{{ stockLevel }} in stock</span>
    } @else {
    <span class="in-stock-text"><b>Sold out</b></span>
    } @if(enableSavedItems){ @if (!productInSaved) {
    <a (click)="addItemToSaved(product ? product.id : searchResult.productId)" pRipple class="save-action">Save for
      later</a>
    } @else {
    <a (click)="addItemToSaved(product ? product.id : searchResult.productId)" pRipple class="save-action">Remove</a>
    } }
  </div>
</div>
